// Module
var code = " <span ng-click=\"vm.goBackHome()\" class=\"fa fa-home logo-house fa-lg\" dv-show-element dv-show-allowed-roles=\"vm.TSRoleUtil.getGesuchstellerOnlyRoles()\" dv-show-expression=\"!vm.isCurrentPageGSDashboard()\" title=\"{{ 'HOME' | translate }}\" aria-label=\"{{ 'HOME' | translate }}\"> </span> ";
// Exports
module.exports = code;